<template>
  <standard-container
    :title="$t('stats.players')"
    overflow="hidden"
    content-height="8vh"
    footer-height="0px"
  >
    <template v-slot:content>
      <v-flex>
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="playerSelected"
              :label="$t('schedule.player-search')"
              :items="players"
              :disabled="disabled"
              prepend-icon="mdi-television"
              hide-details
              clearable
              @change="setPlayer()"
            />
          </v-col>
        </v-row>
      </v-flex>
    </template>
  </standard-container>
</template>

<script>
// Components
import standardContainer from "../Common/StandardContainer";

// Connectors
import { StatsConnector } from "../Database/StatsConnector";

export default {
  components: {
    standardContainer,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statsConnector: new StatsConnector(this.$store.state.user),
      playerSelected: "",
      players: [],
    };
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.createPlayerList();
    }
  },
  methods: {
    createPlayerList() {
      this.statsConnector
        .getPlayers()
        .then((response) => {
          this.players = response;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setPlayer() {
      this.$emit("playerDefined", this.playerSelected);
    },
  },
};
</script>

<style></style>
